export const envVariables = {
	//apiUrl: "http://ec2-54-201-36-9.us-west-2.compute.amazonaws.com:5000"
	apiUrl: "https://api-pf-services.pricemaker.io"
	
}
